var render, staticRenderFns
import script from "./download-bar.vue?vue&type=script&lang=js&"
export * from "./download-bar.vue?vue&type=script&lang=js&"
import style0 from "./download-bar.vue?vue&type=style&index=0&id=12f8eea5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f8eea5",
  null
  
)

/* custom blocks */
import block0 from "./download-bar.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports